import { updatePlanningUnassignedTableState } from '@/entities/gridTables/thunks/updatePlanningUnassignedTableState'
import { scenariosSelectors } from '@/entities/schedules'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

import { ordersSelectors } from '../ordersSelectors'
import { fetchPlanningOrders } from './fetchPlanningOrders'

type FetchOrdersByScenarioPayload = {
  scenarioId: EntityId
  forceRefresh?: boolean
}

export const fetchUnassignedOrdersByScenario = createAsyncThunk<void, FetchOrdersByScenarioPayload, ThunkApiContext>('orders/fetchPlanningOrdersByShift',
  async ({ scenarioId, forceRefresh }, { dispatch, getState }) => {
    const state = getState()
    const scenario = scenariosSelectors.selectById(state, scenarioId)

    if (scenario.unassignedOrders) {
      const orderIds = scenario.unassignedOrders
        .filter((orderId) => orderId !== undefined)
        .filter((orderId) => forceRefresh ? true : (orderId && !ordersSelectors.selectById(state, orderId)))

      if (orderIds.length > 0) {
        await dispatch(fetchPlanningOrders({ orderIds }))
      }

      // Update the relevant unassigned table state after fetching the orders
      await dispatch(updatePlanningUnassignedTableState({ scenarioId }))
    }
  },
)
